/* =========================================================
   EYESHELLS: Split engo-scripts.js -> engo-collection.js
   - Collection/Search UX (sort, grid, filters, drawer, etc.)
   ========================================================= */

(function($){
  $(function(){
    "use strict";

    function sortLayout() {
        $('.prod_per a').click(function(){
          var myClass = $(this).attr("class");
          var collectionProd = $(this).closest('.collection-page-fullwidth').find('.collection_prod');
          collectionProd.removeClass().addClass('collection_prod ' + myClass);
        });
        if ($(window).width() < 1300) {
          $('.size_3').addClass('active');
          $('.size_4').removeClass('active');
          $('.size_5').addClass('d-none');
        }
    
        if ($(window).width() >= 1300) {
          $('.size_3').removeClass('active');
          $('.size_4').addClass('active');
          $('.size_5').removeClass('d-none');
        }
    
        if ($(window).width() < 768) {
          $('.size_2').addClass('active');
          $('.size_4').removeClass('active');
          $('.size_5').addClass('d-none');
          $('.size_4').addClass('d-none');
          $('.size_3').addClass('d-none');
        }
        $(window).resize(function(){
          if ($(window).width() < 1300) {
            $('.size_3').addClass('active');
            $('.size_4').removeClass('active');
            $('.size_5').addClass('d-none');
          }
    
          if ($(window).width() >= 1300) {
            $('.size_3').removeClass('active');
            $('.size_4').addClass('active');
            $('.size_5').removeClass('d-none');
          }
    
          if ($(window).width() < 768) {
            $('.size_2').addClass('active');
            $('.size_4').removeClass('active');
            $('.size_5').addClass('d-none');
            $('.size_4').addClass('d-none');
            $('.size_3').addClass('d-none');
          }
        });
    
        $('.size_5').on('click', function() {
          $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
          $('.js_size_prod').addClass('col-lg-2dot4');
          $(this).addClass('active');
          $('.size_6').removeClass('active');
          $('.size_4').removeClass('active');
          $('.size_3').removeClass('active');
        });
        $('.size_4').on('click', function() {
          $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
          $('.js_size_prod').addClass('col-md-3');
          $(this).addClass('active');
          $('.size_5').removeClass('active');
          $('.size_6').removeClass('active');
          $('.size_3').removeClass('active');
          $('.size_2').removeClass('active');
        });
        $('.size_3').on('click', function() {
          $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12');
          $('.js_size_prod').addClass('col-md-4');
          $(this).addClass('active');
          $('.size_5').removeClass('active');
          $('.size_4').removeClass('active');
          $('.size_6').removeClass('active');
          $('.size_2').removeClass('active');
        });
        $('.size_2').on('click', function() {
          $('.js_size_prod').removeClass('col-lg-1 col-lg-2 col-lg-3 col-lg-4 col-lg-5 col-lg-6 col-lg-7 col-lg-8 col-lg-9 col-lg-10 col-lg-11 col-lg-12 col-lg-2dot4 col-md-1 col-md-2 col-md-3 col-md-4 col-md-5 col-md-6 col-md-7 col-md-8 col-md-9 col-md-10 col-md-11 col-md-12 col-12');
          $('.js_size_prod').addClass('col-6');
          $(this).addClass('active');
          $('.size_3').removeClass('active');
          $('.size_4').removeClass('active');
          $('.size_1').removeClass('active');
        });
      }
    
    function changeProdListGrid(){
        $('.prod_grid').on('click',function(){
          $('.product-grid-view').addClass('active');
          $('.product-list-view').removeClass('active');
          $(this).addClass('active');
          $('.prod_list').removeClass('active');
          $('.prod_per').removeClass('active');
    
        });
        $('.prod_list').on('click',function(){
          $('.product-grid-view').removeClass('active');
          $('.product-list-view').addClass('active');
          $(this).addClass('active');
          $('.prod_grid').removeClass('active');
          $('.prod_per').addClass('active');
        });
      }
    
    function FilterPushLeft(){
        $(document)
          .off('click.eyeshellsFilter')
          .on('click.eyeshellsFilter', '.js_filter', function(e){
            e.preventDefault();
    
            // Close mini cart if it is open (prevents drawer conflicts)
            if ($('.js-minicart').hasClass('active')) {
              $('.js-minicart').removeClass('active');
              $('body').removeClass('es-minicart-open');
            }
    
            $('.filter-to-left').toggleClass('active');
    
            // Shared backdrop: show only when any drawer is open
            var needBackdrop = $('.filter-to-left').hasClass('active') || $('.js-minicart').hasClass('active');
            $('.bg-minicart').toggleClass('active', needBackdrop);
          })
          .on('click.eyeshellsFilter', '.close_filter', function(e){
            e.preventDefault();
            $('.filter-to-left').removeClass('active');
    
            if (!$('.js-minicart').hasClass('active')) {
              $('.bg-minicart').removeClass('active');
            }
          })
          .on('click.eyeshellsFilter', '.bg-minicart', function(e){
            // Close filters when backdrop is clicked and filter is open
            if (!$('.filter-to-left').hasClass('active')) return;
            e.preventDefault();
    
            $('.filter-to-left').removeClass('active');
    
            if (!$('.js-minicart').hasClass('active')) {
              $('.bg-minicart').removeClass('active');
            }
          });
      }
    
    function js_draw_filter(){
        $('.js-draw-filter-btn').on('click',function(){
          $(this).addClass('js-draw-filter-open');
          $(this).removeClass('js-draw-filter-btn');
          $('.js-draw-filter').removeClass('draw_filter').addClass('col-lg-3');
          $('.js-draw-filter-2').removeClass('col-lg-12').addClass('col-lg-9');
    
          $('.js-draw-filter-open').on('click',function(){
            $(this).addClass('js-draw-filter-btn');
            $(this).removeClass('js-draw-filter-open');
            $('.js-draw-filter').addClass('draw_filter').removeClass('col-lg-3');
            $('.js-draw-filter-2').addClass('col-lg-12').removeClass('col-lg-9');
          })
    
          setTimeout(function(){
            js_draw_filter()
          })
        })
      }
    
    function checkclickcol(){
        $('.js-check-click-col').on('click', function(){
          $(this).toggleClass('active');
        })
      }
    
    function listcollection(){
        $('.js_list_col').slick({
          dots: false,
          arrows:true,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 5,
          slidesToScroll: 1,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i> </button>',
          nextArrow:'<button type="button" class="next-slide"> <i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1200,
              settings: {
                slidesToShow: 3,
              }
            },
            {
              breakpoint: 768,
              settings: {
                slidesToShow: 2,
              }
            },
    
            {
              breakpoint: 575,
              settings: {
                slidesToShow: 1,
              }
            }
          ]
        });
    
      }
    
    function jsDScollectionV1(){
        $('.js_ds_collectionv1').slick({
          dots: false,
          arrows:false,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 3,
          slidesToScroll: 1,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2
              }
            },
            {
              breakpoint: 480,
              settings: {
                slidesToShow: 1,
                dots: false, 
                arrows: false
              }
            }
          ]
        });
    
      }
    
    function jscolbreacrumb(){
        $('.js_col_breacrumb').slick({
          dots: false,
          arrows:true,
          infinite: false,
          speed: 300,
          autoplay:false,
          slidesToShow: 5,
          slidesToScroll: 2,
          prevArrow:'<button type="button" class="prev-slide"><i class="fa-solid fa-angle-left"></i></button>',
          nextArrow:'<button type="button" class="next-slide"><i class="fa-solid fa-angle-right"></i></button>',
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                slidesToShow: 4
              }
            },
            {
              breakpoint: 800,
              settings: {
                slidesToShow: 3
              }
            },
            {
              breakpoint: 600,
              settings: {
                slidesToShow: 2
              }
            }
          ]
        });
    
      }

    function runIf(sel, fn){ if (!sel) { try{fn();}catch(e){} return; } if ($(sel).length) { try{fn();}catch(e){} } }
    runIf(".prod_per a", sortLayout);
    runIf(".prod_grid", changeProdListGrid);
    runIf(".js-minicart", FilterPushLeft);
    runIf(".js-draw-filter-btn", js_draw_filter);
    runIf(".js-check-click-col", checkclickcol);
    runIf(".js_list_col", listcollection);
    runIf(".js_ds_collectionv1", jsDScollectionV1);
    runIf(".js_col_breacrumb", jscolbreacrumb);
  });
})(window.jQuery);
